import { ChangeDetectorRef, Component } from "@angular/core";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { takeUntil } from "rxjs/operators";
import { Dictionary } from "projects/sepidz-web-framework/src/lib/models/dictionary";
import { form_control } from "projects/sepidz-web-framework/src/lib/models";
import { FormControlTypes } from "projects/sepidz-web-framework/src/lib/models/form-base-control.model";
import { Zone, ZoneBranch } from "../../model/zone.model";
import { DialogType } from "projects/sepidz-web-framework/src/lib/models/dialog.enum";
import { RowState } from "projects/sepidz-web-framework/src/lib/models/enums";
import { RateIncrease, RoundingTypeAnnouncement } from "../zone-price.enum";
import { ZonePriceAnnouncement, ZonePriceAnnouncementForm } from "../../model/zone-price-announcement.model";

@Component({
  selector: "app-zone-price-announcement-form",
  templateUrl: "./zone-price-announcement-form.component.html",
  styleUrls: ["./zone-price-announcement-form.component.scss"],
})
export class ZonePriceAnnouncementFormComponent extends BaseFormComponent<ZonePriceAnnouncement> {
  DefaultValues: Dictionary = [];
  Zones: form_control[];
  ZonePriceAnnouncementForm: form_control[];
  isDelete: boolean = true;
  erroremessage: string;
  deactivateSave: boolean = false;

  zonePriceAnnouncementForm = new ZonePriceAnnouncementForm();
  zonePriceAnnouncementFormCopy = { ...this.zonePriceAnnouncementForm };

  constructor(protected selectorService: SelectorService, protected cd: ChangeDetectorRef) {
    super(selectorService, cd);
  }

  async ngOnInit() {
    this.apiName = "ZonePriceAnnouncement";
    this.label = this.translate("ClientApp.Pages.PageMenu.ZonePriceAnnouncement");
    super.ngOnInit();
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  //اضافه کردن دکمه اعمال
  setColumnAttribute(): void {
    if (!this.orignalColumns.some((s) => s.name === "addZonePriceBtn")) {
      const addBtn = new form_control();
      addBtn.name = "addZonePriceBtn";
      addBtn.label = this.translate("ClientApp.FrontOffice.Parties.ZonePriceAnnouncement.Actions");
      addBtn.formVisible = true;
      addBtn.userClass = "action-btn";
      addBtn.columnNumber = 1;
      addBtn.controlType = FormControlTypes.Button;
      this.orignalColumns.push(addBtn);
      this.columns = this.orignalColumns;
    }
    super.setColumnAttribute();
    this.Zones = this.getDetailControlModels("Zones");
  }

  onDynamicFormChanges(controlName: string) {
    const IncreaseRateValue = this.formGroup.controls["IncreaseRateOfAmount"].value;
    const AmountTypeIdValue = this.formGroup.controls["AmountTypeId"].value;
    const AmountType = this.selectorService.getDataList("AmountTypeId");
    if (IncreaseRateValue !== null && IncreaseRateValue !== undefined) {
      if (AmountType.find((f) => f.Code === RateIncrease.Percent).Id === AmountTypeIdValue) {
        if (Number(IncreaseRateValue) > 100) {
          this.formGroup.controls["IncreaseRateOfAmount"].setValue(100);
        } else {
          this.zonePriceAnnouncementForm.IncreaseRateOfAmount = IncreaseRateValue;
        }
      } else if (AmountType.find((f) => f.Code === RateIncrease.Rial).Id === AmountTypeIdValue) {
        this.zonePriceAnnouncementForm.IncreaseRateOfAmount = IncreaseRateValue;
      }
      if (controlName === "addZonePriceBtn") {
        this.populateZone();
      }
    }
  }

  populateZone() {
    const branchIdValue = this.formGroup.controls["BranchIds"]?.value || [];
    if (branchIdValue.length === 0) {
      console.error("BranchIds is empty or undefined.");
      return;
    }

    this.httpCommonService
      .getList("Zone")
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(async (data: Zone[]) => {
        const IncreaseRateValue = this.formGroup.controls["IncreaseRateOfAmount"].value;
        const RoundingAmountValue = this.formGroup.controls["RoundingAmount"].value;
        let ZoneList: Zone[] = data;
        ZoneList = this.filterZones(ZoneList, branchIdValue);
        this.model.Zones = [];
        ZoneList?.forEach((zone: Zone) => {
          this.addZonesToList(zone, IncreaseRateValue, RoundingAmountValue);
        });
        this.cd.markForCheck();
      });
  }

  filterZones(zoneList: Zone[], selectedBranchIds: number[]): Zone[] {
    return zoneList.filter((zone) => {
      return zone.Branches.some((branch) => selectedBranchIds.includes(branch.BranchId) && branch.IsActive);
    });
  }

  addZonesToList(zone: Zone, increaseRate: number, roundingAmount: RoundingTypeAnnouncement): void {
    const selectedBranchIds: number[] = this.formGroup.controls["BranchIds"].value;
    zone.Branches.forEach((branch) => {
      selectedBranchIds.forEach((selectedBranchId) => {
        if (branch.BranchId === selectedBranchId) {
          this.zonePriceAnnouncementFormCopy = { ...this.zonePriceAnnouncementForm };
          this.zonePriceAnnouncementFormCopy.ZoneBranch = branch;
          this.zonePriceAnnouncementFormCopy.BranchId = branch.BranchId;
          this.zonePriceAnnouncementFormCopy.ZoneBranchId = branch.Id;
          this.zonePriceAnnouncementFormCopy.BranchTitle = branch.BranchTitle || null;
          this.zonePriceAnnouncementFormCopy.ZoneTitle = zone.Title;
          this.zonePriceAnnouncementFormCopy.ZoneId = zone.Id;
          if (branch.ShippingCost !== null && branch.CourierShippingCost !== null) {
            this.zonePriceAnnouncementFormCopy.OldAmount = branch.ShippingCost;
            this.zonePriceAnnouncementFormCopy.OldAmountDriver = branch.CourierShippingCost;
            const { newAmount, newAmountDriver } = this.calculateNewAmount(branch, increaseRate, roundingAmount);
            if (newAmount !== null && newAmountDriver !== null) {
              this.zonePriceAnnouncementFormCopy.NewAmount = newAmount;
              this.zonePriceAnnouncementFormCopy.NewAmountDriver = newAmountDriver;
              this.Zones.find((f) => f.name === "BranchTitle").disabled = true;
              this.Zones.find((f) => f.name === "ZoneTitle").disabled = true;
              this.Zones.find((f) => f.name === "OldAmount").disabled = true;
              this.Zones.find((f) => f.name === "OldAmountDriver").disabled = true;
              this.zonePriceAnnouncementFormCopy.State = RowState.New;
              this.model.Zones.push(this.zonePriceAnnouncementFormCopy);
            }
          }
        }
      });
    });
  }

  calculateNewAmount(branch: ZoneBranch, increaseRate: number, roundingAmount: number): { newAmount: number; newAmountDriver: number } {
    let newAmount = 0;
    let newAmountDriver = 0;
    const AmountType = this.selectorService.getDataList("AmountTypeId");
    const RoundingType = this.selectorService.getDataList("RoundingTypeId");
    if (AmountType.find((f) => f.Code === RateIncrease.Percent).Id === this.formGroup.controls["AmountTypeId"].value) {
      newAmount = (1 + increaseRate / 100) * branch.ShippingCost;
      newAmountDriver = (1 + increaseRate / 100) * branch.CourierShippingCost;
    } else if (AmountType.find((f) => f.Code === RateIncrease.Rial).Id === this.formGroup.controls["AmountTypeId"].value) {
      newAmount = branch.ShippingCost + increaseRate;
      newAmountDriver = branch.CourierShippingCost + increaseRate;
    }

    if (roundingAmount === 0 || roundingAmount === null || roundingAmount === undefined) {
      return { newAmount, newAmountDriver };
    } else {
      if (RoundingType.find((f) => f.Code === RoundingTypeAnnouncement.Standard).Id === this.formGroup.controls["RoundingTypeId"].value) {
        newAmount = Math.round(newAmount / roundingAmount) * roundingAmount;
        newAmountDriver = Math.round(newAmountDriver / roundingAmount) * roundingAmount;
      } else if (RoundingType.find((f) => f.Code === RoundingTypeAnnouncement.RoundingUp).Id === this.formGroup.controls["RoundingTypeId"].value) {
        newAmount = Math.ceil(newAmount / roundingAmount) * roundingAmount;
        newAmountDriver = Math.ceil(newAmountDriver / roundingAmount) * roundingAmount;
      } else if (RoundingType.find((f) => f.Code === RoundingTypeAnnouncement.RoundingDown).Id === this.formGroup.controls["RoundingTypeId"].value) {
        newAmount = Math.floor(newAmount / roundingAmount) * roundingAmount;
        newAmountDriver = Math.floor(newAmountDriver / roundingAmount) * roundingAmount;
      }
    }
    return { newAmount, newAmountDriver };
  }

  CompleteData(value: { apiName: string; Category: string; data: any[] }) {
    if (value.apiName === "Lookup" && value.Category === "RoundingType") {
      if (!this.model?.RoundingTypeId) {
        this.model.RoundingTypeId = value.data.find((f) => f.Code === RoundingTypeAnnouncement.RoundingUp)?.Id;
        this.setValue("RoundingTypeId", this.model.RoundingTypeId);
      }
    }
    if (value.apiName === "Lookup" && value.Category === "AmountType") {
      if (!this.model?.AmountTypeId) {
        this.model.AmountTypeId = value.data.find((f) => f.Code === RateIncrease.Percent)?.Id;
        this.setValue("AmountTypeId", this.model.AmountTypeId);
      }
    }
  }

  async save() {
    try {
      if (Object.keys(this.zonePriceAnnouncementFormCopy).length) {
        this.sts.showDialog(
          this.translate("ClientApp.FrontOffice.Parties.ZonePriceAnnouncement.InformationCannotEditedAfterSaving"),
          this.translate("ClientApp.FrontOffice.Parties.ZonePriceAnnouncement.Warning"),
          DialogType.confirm,
          () => super.save(),
          () => this.selectorService.submitted$.next(this.submitted)
        );
      } else {
        this.sts.showDialog(
          this.translate("ClientApp.FrontOffice.Parties.ZonePriceAnnouncement.MakeEntriesAndApplyChangesBeforeSaving"),
          this.translate("ClientApp.FrontOffice.Parties.ZonePriceAnnouncement.Attention"),
          DialogType.alert,
          () => this.selectorService.submitted$.next(this.submitted)
        );
      }
    } catch {
      return;
    }
  }
}
